<div class="container-fluid">

    <div class="row" *ngIf="isEditing">
        <div class="col-md-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>

    </div>

    <div class="row" *ngIf="isEditing">
        <div class="col-md-12">
            <div class="routes-1 opensans-semi-bold-sapphire-30px">
                <span class="opensans-semi-bold-sapphire-30px">Timetable</span>
                <div class="rectangle-210"></div>
                <br/>
            </div>
        </div>
    </div>


    <div class="col-md-12">
        <div class="page_header mt-20">
            <h5 class="heading">Route timetable for {{ dataCntrl?.application?.route_summary}}</h5>
            <div *ngIf="isProcess && isEditing" style="align-content: right; text-align: right">
                <a title="Add a forward timetable"
                   [disabled]="dataCntrl?.application?.route_id==null || dataCntrl?.application?.route_id=='' || isDuplicateMode"
                   style="cursor: pointer" (click)="addNew()">
                    <img src="../../../assets/newimg/add-circle-4@2x.png" title="Add a forward timetable"
                    /> <b class="opensans-semi-bold-sapphire-16px"> Add A New Forward Timetable</b>
                </a>
                <br/>
                <br/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <table class="table  table-hover">
                    <thead class="th-background">
                    <tr>
                        <th>Forward or Return</th>
                        <th>Interval</th>
                        <th>Total Distance (KM)</th>
                        <th>Total Time</th>
                        <th>Number of Border Crossings</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody *ngIf="timeTableList.length>0">
                    <ng-container *ngFor="let list of timeTableList; let i=index;">
                        <tr
                                id="table-record-{{i}}">
                            <td><a [routerLink]="" (click)="showDepartures(list,i,$event)"
                                   style="color:#00008b; text-decoration: underline;"><span
                                    title="View account details">{{list.timetable_direction}}</span></a>
                            </td>

                            <td>{{list.timetable_interval}}</td>
                            <td>{{list.total_distance}}</td>
                            <td>
                                <ng-container>{{getTotalCtime(list.total_time)}}</ng-container>
                            </td>
                            <td>{{list.number_BCs}}</td><!--Replace i+1 with timetable id-->
                            <td style="min-width:50px!important;" *ngIf="isProcess">

                                    <span title="Change Interval" (click)="onMenuChange('return',list.id,null,i)"  *ngIf="isEditing">
                                        <img src="../../../assets/newimg/return_24.png"
                                             title="Generate Return Timetable Interval" style="width: 50px;height:50px;"
                                             [disabled]="isDuplicateMode" *ngIf="isForward(list.timetable_direction)"
                                             (click)="onMenuChange('return',list.id,null,i)"
                                             style="cursor: pointer"/>
                                    </span>
                                &nbsp; &nbsp;
                                <span *ngIf="isEditing" title="Change Interval" (click)="showDepartures(list,i,$event)">
                                        <img src="../../../assets/newimg/border-color-58@2x.png"
                                             title="Edit the timetable details" style="width: 50px;height:50px;"
                                             [disabled]="isDuplicateMode"
                                             (click)="showDepartures(list,i,$event)"
                                             style="cursor: pointer"/>
                                    </span>

                                <span *ngIf="!isEditing" title="Change Interval" (click)="showDepartures(list,i,$event)">
                                        <img src="../../../assets/newimg/visibility-2@2x.png"
                                             title="Edit the timetable details" style="width: 50px;height:50px;"
                                             [disabled]="isDuplicateMode"
                                             (click)="showDepartures(list,i,$event)"
                                             style="cursor: pointer"/>
                                    </span>
                                &nbsp; &nbsp;
                                <span title="Change Interval" (click)="onMenuChange('delete',list.id,null,i)"  *ngIf="isEditing">
                                        <img src="../../../assets/newimg/delete-42@2x.png" title="Delete Timetable"
                                             style="width: 50px;height:50px;" [disabled]="isDuplicateMode"
                                             (click)="onMenuChange('delete',list.id,null,i)"
                                             style="cursor: pointer"/>
                                    </span>

                                <!--                                    <select class="form-control" *ngIf="!isDuplicateMode" (change)="onMenuChange(menu.value,list.id,menu,i)" #menu>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="null">Select Action</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="edit">Edit Interval</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  *ngIf="isForward(list.timetable_direction)" value="return">Make Return Route</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="delete">Delete Route</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="edit-detail">Edit Detail</option>-->

                                <!--                                    </select>-->
                                <!--                                    <select *ngIf="isDuplicateMode" class="form-control" [attr.disabled]="isDuplicateMode" (change)="onMenuChange(menu.value,list.id,menu,i)" #menu>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="null">Select Action</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="edit">Edit Interval</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  *ngIf="isForward(list.timetable_direction)" value="return">Make Return Route</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="delete">Delete Route</option>-->
                                <!--                                        <option  [disabled]="isDuplicateMode"  value="edit-detail">Edit Detail</option>-->
                                <!--                                    </select>-->
                            </td>
                        </tr>
                        <ng-container *ngIf="list.showBlock && selectedTimetable === list">
                            <tr id="departureData-{{i}}" class="departure-data mrg-tp disable-hover">
                                <td colspan="8">
                                    <div class="opensans-bold-catalina-blue-16px mb-3">
                                        {{list.timetable_direction}} Timetable Details
                                        <br/>
                                    </div>
                                    <div class="opensans-bold-sapphire-16px mb-3">
                                        Interval:  {{list.timetable_interval}} &nbsp;&nbsp;&nbsp; <a
                                            title="Change Interval" (click)="onMenuChange('edit',list.id,null,i)">
                                        <img *ngIf="isEditing" src="../../../assets/newimg/border-color-58@2x.png" title="Change Interval"
                                             (click)="onMenuChange('edit',list.id,null,i)"
                                             style="cursor: pointer"/>
                                    </a>
                                        <br/>
                                    </div>
                                    <div class="opensans-normal-black-14px">
                                        Please enter your times in the following format: 08:30, 22:15 or 10:30.
                                        <br/>
                                    </div>
                                    <table class="table">
                                        <thead class="th-background">
                                        <!--                                        <tr style="background-color:white;">-->
                                        <!--                                            <th colspan="6" class="" style="border:none!important;"></th>-->
                                        <!--                                            &lt;!&ndash;<th> Departure </th>-->
                                        <!--                                            <th>Type of stop </th>-->
                                        <!--                                            <th>Distance</th>-->
                                        <!--                                            <th style="min-width:160px">Arrive</th>-->
                                        <!--                                            <th style="min-width:160px">Depart</th>&ndash;&gt;-->
                                        <!--                                            <th colspan="2" class="text-center">Duration</th>-->
                                        <!--                                        </tr>-->
                                        <tr>
                                            <!--<th style="border:none!important;"></th>-->
                                            <th colspan="2">Place</th>
                                            <th>Type of stop</th>
                                            <th>Distance</th>
                                            <th style="min-width:160px">Arrival Time</th>
                                            <th style="min-width:160px">Departure Time</th>
                                            <th style="display: none;">Total travel <br/> time</th>
                                            <th style="display: none;">Total stop <br/> time</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        <ng-container *ngFor="let item of departuresList; let j=index;">
                                            <tr style="border: 1px solid #dcd9d9!important;">
                                                <td>{{item.from_country}}</td>
                                                <td>
                                                    <ng-container *ngIf="j==0 && list.timetable_direction=='Forward'">
                                                        {{item.from_place}}
                                                    </ng-container>
                                                    <ng-container *ngIf="j==0 && list.timetable_direction=='Return'">
                                                        {{item.to_place}}
                                                    </ng-container>
                                                    <ng-container *ngIf="item.step_num!=99 && j!=0">
                                                        {{item.from_place}}
                                                    </ng-container>
                                                    <ng-container
                                                            *ngIf="item.step_num==99 && j!=departuresList.length-1 && j!=0">
                                                        {{item.from_place}}
                                                    </ng-container>
                                                    <ng-container
                                                            *ngIf="item.step_num==99 && j==departuresList.length-1">
                                                        {{item.to_place}}
                                                    </ng-container>


                                                </td>
                                                <td>
                                                    <ng-container *ngIf="!editFlag">
                                                        <!--<select name="type_of_stop" [disabled]="j==0 || j==departuresList.length-1" [(ngModel)]="item.type_of_stop">
                                                          <option value="null">select</option>
                                                          <option *ngFor="let item of utility.listStops;" [value]="item.key">{{item.value}}</option>
                                                        </select>-->
                                                        <span>{{showStopType(item, j == departuresList.length - 1)}}</span>
                                                    </ng-container>
                                                    <ng-container *ngIf="editFlag">
                                                        <!--{{item.stop}}-->
                                                        <span>{{showStopType(item, j == departuresList.length - 1)}}</span>
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="!editFlag && j!=0">
                                                        <input [disabled]="isDuplicateMode" type="text"
                                                               (keypress)="numberOnly($event)" value="{{item.distance}}"
                                                               name="distance-{{j}}" [(ngModel)]="item.distance">
                                                    </ng-container>
                                                    <ng-container *ngIf="editFlag || j==0">
                                                        {{item.distance}}
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="!editFlag && j!=0">
                                                        <input [disabled]="isDuplicateMode" type="text"
                                                               style="width:90%" (blur)="validateInput(item,j)"
                                                               [ngClass]="{'error-input':item.errorFlag}"
                                                               value="{{item.arrive_time}}" name="arrive_time-{{j}}"
                                                               id="arriveTime-{{j}}" class="arriveTime"
                                                               [(ngModel)]="item.arrive_time">
                                                        <sup *ngIf="item.showArrive" class="super-script">+1</sup>
                                                    </ng-container>
                                                    <ng-container *ngIf="editFlag && j!=0">
                                                        {{item.arrive_time | customTimeZone}}
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="!editFlag && j!=(departuresList.length-1)">
                                                        <input [disabled]="isDuplicateMode" type="text"
                                                               style="width:90%" (blur)="validateDepartInput(item,j)"
                                                               [ngClass]="{'error-input':item.departError}"
                                                               id="departTime-{{j}}" class="departTime"
                                                               value="{{item.depart_time}}" name="departTime-{{j}}"
                                                               [(ngModel)]="item.depart_time">
                                                        <sup *ngIf="item.showDepart" class="super-script">+1</sup>
                                                    </ng-container>
                                                    <ng-container *ngIf="editFlag &&  j!=(departuresList.length-1)">
                                                        {{item.depart_time | customTimeZone}}
                                                    </ng-container>
                                                </td>
                                                <td style="display: none;">
                                                    <ng-container *ngIf="j!=0">
                                                        {{item.travalTime}}

                                                    </ng-container>
                                                </td>
                                                <td style="display: none;">
                                                    <ng-container *ngIf="j!=(departuresList.length-1) && j!=0">
                                                        {{item.departTime}}
                                                    </ng-container>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <th colspan="2" style="background-color:white;"></th>
                                            <!--<th  class="cell-st"></th>-->
                                            <th>Total</th>
                                            <th colspan="3">
                                                {{getTotalDistance()}}
                                            </th>
                                            <!--<th></th>
                                            <th></th>-->
                                            <!-- <th>{{getTotalArrivalTime('arrive_time')}}</th> -->
                                            <!-- <th>{{getTotalArrivalTime('depart_time')}}</th> -->
                                            <th style="display: none;">{{getTotalArrivalTime('travalTime')}}</th>
                                            <th style="display: none;">{{getTotalDepartTime('travelStop')}}</th>
                                        </tr>
                                        <tr>
                                            <!--<th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>-->
                                            <th colspan="4" class="cell-st"></th>
                                            <th class="cell-st" colspan="2" *ngIf="isEditing">

                                                <!--</th>
                                                <th  class="cell-st">-->
                                                <button title="Cancel" [disabled]="isDuplicateMode"
                                                        class=" btn-add btn btn-primary btn-sm pull-right"
                                                        (click)="closeDepartue()">
                                                    Cancel
                                                </button>
                                                <button style="margin-right:4px!important;" title="Save"
                                                        *ngIf="isProcess" [disabled]="isDuplicateMode"
                                                        (click)="saveDeparture(list.timetable_direction)"
                                                        class=" btn-add btn btn-primary btn-sm pull-right">
                                                    Save
                                                </button>
                                            </th>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="col-12" *ngIf="dataCntrl.status != 2 && isEditing">
        <ng-container *ngIf="isProcess">
            <div class="no-mp">
                <button *ngIf="utility.isView" title="Cancel"  (click)="cancelApplication()"  type="submit" id="btnCancel" class="btn hd-btn-close">
                    Close
                </button>
                <button  class="btn hd-btn ml-2" (click)="goBack()" title="Back">Back</button>
                <button  *ngIf="isExternalRole" title="Save & Continue to step 4" (click)="saveTable()"   type="submit" id="btnSave" class="btn hd-btn">
                    Next
                </button>

                <button *ngIf="!isExternalRole" title="Continue to step 3" (click)="goNextStep()"  type="submit" class="btn  hd-btn">
                    Next
                </button>

            </div>

        </ng-container>
    </div>

    <div class="row" *ngIf="isEditing">
        <div class="col-12">
            <button data-toggle="modal" data-target="#Manager" id="secretButton" style="display:none"><i
                    class="fa fa-save"></i>Save
            </button>
            <!--Manage Timetable-->
            <div class="modal fade" id="Manager" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">

                            <button type="button" class="close" data-dismiss="modal" #closebutton aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body modal-lg">
                            <!--                            <manage [dataCntrl]="dataCntrl" *ngIf="dataCntrl.timeId==0"></manage>-->
                            <manage [dataCntrl]="dataCntrl" [isReturnTimeTable]="isReturnTimetable"
                                    [timeTableIndex]="timeTableIndex"></manage>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-12">
                                    <button type="button" id="timeBtn" (click)="getTimeTable('create')"
                                            style="display:none;"></button>
                                    <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
                                            (click)="onClose()">Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--<div class="container-fluid">-->
<!--    <div class="card border-light shadow-sm">-->
<!--        <div class="row">-->
<!--            <div class="col-md-12" *ngIf="isLoading">-->
<!--                <app-busy [message]="message"></app-busy>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="row">-->

<!--            <div class="routes-1 opensans-semi-bold-sapphire-30px">-->
<!--                <span class="opensans-semi-bold-sapphire-30px"> <b>Timetable For : </b>{{ dataCntrl?.application?.route_summary}}</span>-->
<!--                <div class="rectangle-210"></div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <br/>-->
<!--        <br/>-->
<!--        <div class="col-md-12">-->
<!--            <h4>Forward Timetable</h4>-->
<!--            <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">-->
<!--                <h6>Intervals</h6>-->
<!--                <table style="width:100%;">-->
<!--                    <tr>-->
<!--                        <th style="text-align:center;width: 16%;">Select all</th>-->
<!--                        <th style="text-align:center;width: 12%;">Monday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Tuesday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Wednesday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Thursday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Friday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Saturday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Sunday</th>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                        <td>-->
<!--                            <input formControlName="is_all" type="checkbox" (change)="isAll($event)" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:37%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day1" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day2" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day3" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day4" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day5" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day6" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day7" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                        <td colspan="8" *ngIf="!dataCntrl.isReturned" class="text-right" style="margin-top:10px!important;padding-top:35px!important;">-->
<!--                            <button *ngIf="!isCreated" type="submit" [disabled]="!isValidForm()"-->
<!--                                    class="btn btn-md btn-success" style="width:auto; margin-left:10px; ">-->
<!--                                &lt;!&ndash; <i class="fa fa-save"></i> &ndash;&gt;-->
<!--                                Save Timetable-->
<!--                            </button>-->
<!--                            <button *ngIf="isCreated" type="submit" [disabled]="!isValidForm()"-->
<!--                                    class="btn btn-md btn-success" style="width:auto; margin-left:10px; ">-->
<!--                                Create Timetable-->
<!--                            </button>-->

<!--                        </td>-->
<!--                        <td colspan="8" *ngIf="dataCntrl.isReturned" class="text-right" style="margin-top:10px!important;padding-top:10px!important;">-->
<!--                            <button type="submit"  id="btnCreateReturn" [disabled]="!isValidForm()"-->
<!--                                    class="btn btn-md btn-success" style="width:auto; margin-left:10px; ">-->
<!--                                Create Return Timetable-->
<!--                            </button>-->

<!--                        </td>-->
<!--                    </tr>-->

<!--                </table>-->
<!--                <h6>Timetable Details</h6>-->
<!--                <table style="width:100%;">-->
<!--                    <tr>-->
<!--                        <th style="text-align:center;width: 16%;">Select all</th>-->
<!--                        <th style="text-align:center;width: 12%;">Monday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Tuesday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Wednesday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Thursday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Friday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Saturday</th>-->
<!--                        <th style="text-align:center;width: 12%;">Sunday</th>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                        <td>-->
<!--                            <input formControlName="is_all" type="checkbox" (change)="isAll($event)" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:37%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day1" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day2" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day3" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day4" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day5" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day6" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <input formControlName="is_for_day7" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                        <td colspan="8" *ngIf="!dataCntrl.isReturned" class="text-right" style="margin-top:10px!important;padding-top:35px!important;">-->
<!--                            <button *ngIf="!isCreated" type="submit" [disabled]="!isValidForm()"-->
<!--                                    class="btn btn-md btn-success" style="width:auto; margin-left:10px; ">-->
<!--                                &lt;!&ndash; <i class="fa fa-save"></i> &ndash;&gt;-->
<!--                                Save Timetable-->
<!--                            </button>-->
<!--                            <button *ngIf="isCreated" type="submit" [disabled]="!isValidForm()"-->
<!--                                    class="btn btn-md btn-success" style="width:auto; margin-left:10px; ">-->
<!--                                Create Timetable-->
<!--                            </button>-->

<!--                        </td>-->
<!--                        <td colspan="8" *ngIf="dataCntrl.isReturned" class="text-right" style="margin-top:10px!important;padding-top:10px!important;">-->
<!--                            <button type="submit"  id="btnCreateReturn" [disabled]="!isValidForm()"-->
<!--                                    class="btn btn-md btn-success" style="width:auto; margin-left:10px; ">-->
<!--                                Create Return Timetable-->
<!--                            </button>-->

<!--                        </td>-->
<!--                    </tr>-->

<!--                </table>-->

<!--            </form>-->


<!--&lt;!&ndash;         <div class="col-md-12 p-0" id="test2">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="col-sm-12 p-0" >&ndash;&gt;-->

<!--&lt;!&ndash;                    <div id="editor"  class="cke_chrome">&ndash;&gt;-->
<!--&lt;!&ndash;                        <ckeditor [(ngModel)]="timeTableDetail"></ckeditor>&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash;            <quill-editor [styles]="{height: '400px'}"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash;                          [modules]="quillConfig" [(ngModel)]="timeTableDetail" >&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                        &lt;!&ndash;            </quill-editor>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash; </form> &ndash;&gt;-->

<!--        </div>-->
<!--        <div class="col-12" *ngIf="dataCntrl.status != 2 && !isApproval">-->

<!--            <ng-container *ngIf="isProcess">-->
<!--                <button class="btn btn-md m-clr pull-right hd-btn mt-2"  (click)="cancelApplication()" title="Cancel"  style="float: right !important;">Cancel</button>-->
<!--                <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2"  (click)="goBack()"  title="Back"  style="float: left !important;">Back</button>-->
<!--                <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveTable()" title="Save & Continueto step 4"  style="float: right !important;" >Save & Continue</button>-->
<!--            </ng-container>-->
<!--        </div>-->
<!--        <div *ngIf="isApproval" class="col-12">-->
<!--            <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2"  (click)="goBack()"  title="Back"  style="float: left !important;">Back</button>-->
<!--            <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveTable()" title="Update Time-Table"  style="float: right !important;" >Update Time-Table</button>-->

<!--        </div>-->
<!--    </div>-->
<!--</div>-->

